import PropTypes from 'prop-types';

import { Container, Modal } from '@mantine/core';

import { Dock } from 'primitives/Dock/Dock';

export default function DockedModal({
  children,
  dockButtons,
  dockProps,
  fullScreen,
  opened,
  onClose,
  padding,
  paddingBottom,
  size = 'md',
  stacked,
  styles,
  title,
  testId,
}) {
  const modalPadding = padding ?? (size === 'sm' ? 'md' : 'xl');
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      data-testid={testId}
      fullScreen={fullScreen}
      variant="withDock"
      size={size}
      styles={styles}
    >
      <Container px={modalPadding} pb={paddingBottom ?? modalPadding}>
        {children}
      </Container>
      {dockButtons && (
        <Dock size={size} stacked={stacked} {...dockProps}>
          {dockButtons}
        </Dock>
      )}
    </Modal>
  );
}

DockedModal.propTypes = {
  children: PropTypes.node,
  dockButtons: PropTypes.node,
  dockProps: PropTypes.object,
  fullScreen: PropTypes.bool,
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  padding: PropTypes.string,
  paddingBottom: PropTypes.string,
  size: PropTypes.string,
  stacked: PropTypes.bool,
  styles: PropTypes.object,
  title: PropTypes.string,
  testId: PropTypes.string,
};
